import {Types}      from "@Common/types";
import {cascadeMap} from "@Common/utils/cascade";
import {upperCase1} from "@Common/utils/strings";

export const mapAppliedPaymentsAsList = ({appliedCredits, appliedPayments}:{
    appliedCredits  : Types.Apis.Models.AppliedCredits,
    appliedPayments : Types.Apis.Models.AppliedPayments,
}) => (
    cascadeMap({...appliedCredits, ...appliedPayments}, "[*][*]", (concept, [conceptType]) => ({
        comments    : "comments" in concept && concept.comments,
        meta1Label  : "meta1Label" in concept && concept.meta1Label,
        meta1Value  : "meta1" in concept && concept.meta1,
        meta2Label  : "meta2Label" in concept && concept.meta2Label,
        meta2Value  : "meta2" in concept && concept.meta2,
        label       : "name" in concept ? concept.name : null,
        type        : conceptType.replace(/s$/, "").split(/(?=[A-Z])/).map(upperCase1).join(" "),
        value       : concept.amount,
    }))
);

